import { render } from "./NavItem.vue?vue&type=template&id=955b14a2"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=955b14a2&lang=css"
script.render = render

export default script